export default {
  title: 'Profil',
  fields: {
    name: {
      label: 'Name',
      placeholder: 'Enter restaurant name',
    },
    short_name: {
      label: 'Short name',
      placeholder: 'Enter restaurant short name',
      tooltip:
        'Sometimes restaurant default names are very long and may contain secondary information, so in some cases (e.g. for shorter notifications) a shorter version of the name is required',
    },
    phone_number: {
      label: 'Phone number',
      placeholder: 'Enter restaurant phone number',
    },
    email: {
      label: 'Email',
      placeholder: 'Enter restaurant email',
    },
    slug: {
      label: 'Slug',
      placeholder: 'Brand slug',
    },
    language: {
      label: 'Language',
      placeholder: 'Use the group default',
      tooltip:
        "The language customers see on this restaurant's storefront, and the default for its staff. Leave it empty to follow the brand's language. Staff can still pick their own language for their own view.",
    },
    sms_name: {
      label: 'SMS Name',
      placeholder: 'SMS display name',
    },
    instagram_link: {
      label: 'Instagram link',
      placeholder: 'Enter restaurant instagram link',
    },
    website_link: {
      label: 'Website link',
      placeholder: 'Enter restaurant website link',
    },
    impressum_link: {
      label: 'Impressum link',
      placeholder: 'Enter restaurant impressum link',
    },
    timezone: {
      label: 'Timezone',
      placeholder: 'Search for a city or timezone',
      tooltip:
        "The timezone this restaurant operates in. It drives order timestamps, opening hours and scheduled order slots. It was set from the restaurant's address when the restaurant was created — correct it here if it is wrong.",
    },
    time_format: {
      label: 'Time format',
      placeholder: "Use the country's default",
      tooltip:
        "How times are shown to your team, across the dashboard and the orders portal. Leave it empty to follow the convention of the restaurant's region.",
      options: {
        '12h': '12-hour (5:30 pm)',
        '24h': '24-hour (17:30)',
      },
    },
    primary_color: {
      label: 'Primary color',
    },
    restaurant_type: {
      label: 'Restaurant type & service model',
    },
    cuisine_types: {
      label: 'Food categories & cuisine types',
    },
  },
  test_restaurant: {
    title: 'Test restaurant',
    description:
      'Make this your test restaurant to try printing, e-mails, orders and integrations in production. It keeps working like any other restaurant and is never billed. You can have one test restaurant.',
    description_test:
      'This is your test restaurant. It works like any other restaurant and is never billed. Customer e-mails and SMS about its orders start with [TEST].',
    mark: 'Mark as test restaurant',
    remove: 'Remove Test designation',
    slot_taken:
      'You already have a test restaurant ({{name}}). Remove the Test designation from your existing one first.',
  },
  buttons: {
    save: 'Save',
  },
  toasts: {
    info_updated: 'Successfully updated the settings',
  },
};
